
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

import {Tooltip} from "antd";
import React from 'react';

export const formatDateAndTime = (dateTime: string) => {
    if(!dateTime) {
        return "";
    }
    return new Date(dateTime).toLocaleDateString('en-GB') + " " + new Date(dateTime).toLocaleTimeString()
}

export const formatDateAndTimeFromNow = (dateTime: string) => {
    return dayjs(dateTime).fromNow()
}


export const formatDateAndTimeFromNowWithTooltip = (dateTime: string) => {
    return <Tooltip title={formatDateAndTime(dateTime)}>{dayjs(dateTime).fromNow()}</Tooltip>
}
